<template>
  <table class="table my-2">
    <thead>
      <tr>
        <th class="text-nowrap table-title">{{ title }}</th>
      </tr>
    </thead>
    <tbody>
      <table class="table table-bordered">
        <thead>
          <tr class="flex">
            <th class="text-nowrap col-4 text-center"></th>
            <th class="text-nowrap col-4 text-center">Até a data da reforma</th>
            <th class="text-nowrap col-4 text-center">Até a data do parecer</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="!isCareerTable">
            <tr class="flex">
              <td class="text-nowrap col-4 text-center">Vínculo atual</td>
              <td class="text-nowrap col-4 text-center">{{ currentTimeAtRegime }}</td>
              <td class="text-nowrap col-4 text-center">{{ currentTimeAtCalculationDate }}</td>
            </tr>
            <tr class="flex">
              <td class="text-nowrap col-4 text-center">Outros vínculos</td>
              <td class="text-nowrap col-4 text-center">{{ othersTimeAtRegime }}</td>
              <td class="text-nowrap col-4 text-center">{{ othersTimeAtCalculationDate }}</td>
            </tr>
            <tr class="flex">
              <td class="text-nowrap col-4 text-center bold">Tempo total</td>
              <td class="text-nowrap col-4 text-center">{{ totalTimeAtRegime }}</td>
              <td class="text-nowrap col-4 text-center">{{ totalTimeAtCalculationDate }}</td>
            </tr>
          </template>
          <template v-else>
            <tr class="flex">
              <td class="text-nowrap col-4 text-center">Tempo no cargo atual</td>
              <td class="text-nowrap col-4 text-center">{{ currentTimeAtRegime }}</td>
              <td class="text-nowrap col-4 text-center">{{ currentTimeAtCalculationDate }}</td>
            </tr>
            <tr class="flex">
              <td class="text-nowrap col-4 text-center">Tempo na carreira atual</td>
              <td class="text-nowrap col-4 text-center">{{ othersTimeAtRegime }}</td>
              <td class="text-nowrap col-4 text-center">{{ othersTimeAtCalculationDate }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'TimeTable',
  props: {
    title: {
      type: String,
      required: true
    },
    currentTimeAtRegime: {
      type: String,
      required: true    
    },
    currentTimeAtCalculationDate: {
      type: String,
      required: true
    },
    othersTimeAtRegime: {
      type: String,
      required: true
    },
    othersTimeAtCalculationDate: {
      type: String,
      required: true
    },
    totalTimeAtRegime: {
      type: String,
      default: ''
    },
    totalTimeAtCalculationDate: {
      type: String,
      default: ''
    },
    isCareerTable: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.table-title {
  background-color: #dbe5f1;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 0;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.bold {
  font-weight: bold;
}
</style> 